module.exports = __webpack_public_path__ + "static/media/mascot_disable_hourglass76608225898f29407ef44fd605fc1f8b.webp";